import { Badge } from '@/components/ui/badge';
import { cn } from '@/components/ui/utils';

interface TierBadgeProps {
  tier: string;
  showLabel?: boolean;
  className?: string;
}

const TIER_STYLES: Record<string, { variant: 'default' | 'secondary' | 'destructive' | 'outline'; className: string; label: string }> = {
  none: { variant: 'secondary', className: 'bg-muted text-muted-foreground', label: 'No Bonus' },
  tier1: { variant: 'default', className: 'bg-info/15 text-info', label: '5% Bonus' },
  tier2: { variant: 'default', className: 'bg-warning/15 text-warning', label: '7.5% Bonus' },
  tier3: { variant: 'default', className: 'bg-success/15 text-success', label: '10% Bonus' },
};

export function TierBadge({ tier, showLabel = true, className }: TierBadgeProps) {
  const style = TIER_STYLES[tier] || TIER_STYLES.none;

  return (
    <Badge
      variant={style.variant}
      className={cn(style.className, className)}
    >
      {showLabel ? style.label : `${tier === 'none' ? '0' : tier === 'tier1' ? '5' : tier === 'tier2' ? '7.5' : '10'}%`}
    </Badge>
  );
}
